/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$('document').ready(function(){

  $('.current-sort-value').text( $('.Popover__Value.is-selected').text() ); // Showing Current Sort Value on Page Load
 
  $('.Popover__Value').click(function(){
    $('.current-sort-value').text( $(this).text() );
  }); 
  
  $(document).on('click','#quick-view .quick-close',function(e){ 
    $('.fancybox-overlay').css('display','none!important');
  })
   
  $('#shopify-section-product-template .Product__SlideshowNav.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller').slick({
    dots: false,
    infinite: false,
    arrows:true,    
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
   
  });
  
    
  
  
  $('#shopify-section-product-template .ingredientSlider1').slick({
    dots: true,
    infinite: false,
    arrows:false,
    speed: 300,
    appendDots: '.dotsWrapper1',
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true
   
  });  
  
  let url = window.location.pathname;
  if(url == '/apps/store-locator'){
  	$('body').addClass('storeLocatorPage');
  }
  else{
  $('body').removeClass('storeLocatorPage');
  }
  if($('body').hasClass('template-product')){
    var yotpoInterval = setInterval(function(){
      var _yotpoAvg = $('.yotpo-stars-and-sum-reviews');
      if(_yotpoAvg.length > 0){
      	var _yotpoAvgRating = _yotpoAvg.find('.yotpo-stars .sr-only').text().replace('star rating', '').trim();
        _yotpoAvg.prepend('<sapn class="yotpo-avg-review">' + _yotpoAvgRating + '</span>');
        clearInterval(yotpoInterval);
      }
    })
  }
  
});